<template>
  <v-sheet
    class="top-bar d-flex"
    height="58px"
  >
    <div class="w-50 px-6 d-flex justify-space-between">
      <v-btn
        class="my-auto mr-2"
        color="primary"
        rounded="lg"
        elevation="0"
        size="small"
        @click="restoreRevision"
      >
        Restore this revision
      </v-btn>

      <v-btn
        icon="mdi-close"
        variant="text"
        size="small"
        class="my-auto mr-2"
        @click="closeSideRevision"
      />
    </div>
    <div class="w-50" />
  </v-sheet>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useRouter } from 'vue-router';
import { useAppRoute } from '@/stores/app/route';
import { useModals } from '@/stores/modals/modals';

const { route } = storeToRefs(useAppRoute());
const router = useRouter();
const { setModal } = useModals();

const closeSideRevision = () => {
  router.push({ query: { ...(route.value?.query || {}), sideRevision: undefined } });
};

const restoreRevision = () => {
  setModal({ field: 'restoreRevisionConfirm', value: true });
};
</script>
